import { createContext } from "react";

interface IBackendContext {
    backend: string;
}
export const BackendContext = createContext<IBackendContext>({
    backend: process.env.REACT_APP_BACKEND_URL!,
});